import { motion } from 'framer-motion'
import React from 'react'
import {
  animationAppTransitions,
  animationAppVariants
} from '../../Helpers/pageAnimation'
import { useSubscriptionStyles } from './styles'

interface LayoutProps {
  children?: React.ReactNode
}

const SubscriptionLayout = ({ children }: LayoutProps): JSX.Element => {
  const classes = useSubscriptionStyles()

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
      className={classes.root}
    >
      <div className={classes.list}>{children}</div>
    </motion.div>
  )
}

export default SubscriptionLayout
